import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-icon-button',
  standalone: false,
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconButtonComponent {
  @Input() iconClass: string = 'fas fa-circle';
  @Input() title: string = '';
  @Input() ariaLabel: string = '';
  @Input() sizeClass: string = 'w-10 h-10';
  @Input() bgClass: string = 'bg-white';
  @Input() textClass: string = 'text-primary';
  @Input() disabled: boolean = false;
  @Output() clicked = new EventEmitter<void>();

  // tooltip state (custom grey tooltip shown below button for 1s)
  showTooltip: boolean = false;
  private _tooltipTimer: any = null;

  constructor(private cdr: ChangeDetectorRef) {}

  onClick(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    if (this.disabled) return;
    this.clicked.emit();
  }

  onMouseEnter(): void {
    this.clearTooltipTimer();
    this.showTooltip = true;
    this.cdr.detectChanges();
  }

  onMouseLeave(): void {
    this.clearTooltipTimer();
    this.showTooltip = false;
    this.cdr.markForCheck();
  }

  private clearTooltipTimer(): void {
    if (this._tooltipTimer) {
      clearTimeout(this._tooltipTimer);
      this._tooltipTimer = null;
    }
  }
}

